export class Tag {
  public id: string;
  public text: string;
  public workspaceId: string;
  public type: TagType;

  constructor(tag: any = undefined) {
    if (tag) {
      this.id = tag.id;
      this.text = tag.text;
      this.workspaceId = tag.workspaceId;
      this.type = tag.type;
      // Handling for creating a new tag
      if (this.id === this.text) {
        this.id = undefined;
      }
    }
  }

  public isSameTag(tagText: string) {
    return this.text === tagText;
  }
}

export enum TagType {
  Person = 'Person',
  PersonCredentialScenario = 'PersonCredentialScenario',
}
